import type { Message } from "$lib/types.js";
import { isMe } from "$lib/session-scope.js";

// Only an optimistic row created in this tab expresses send intent. Canonical
// broadcasts carry clientMsgId too, including sends from our other devices.
export function messageArrival(
  message: { id: string; fromId?: string | null },
  viewer: Parameters<typeof isMe>[1],
) {
  const own = isMe(message.fromId, viewer);
  return { own, localSend: own && message.id.startsWith("local-") };
}

// Only Retry asks the list to follow its row, once; a mark not taken in RETRY_FOLLOW_MS is dropped.
const RETRY_FOLLOW_MS = 1000;
let retryFollow: { id: string; at: number } | undefined;

export function followRetriedSend(localId: string): void {
  retryFollow = { id: localId, at: performance.now() };
}

export function takeRetriedSend(rows: readonly Message[]): Message | undefined {
  if (!retryFollow) return undefined;
  if (performance.now() - retryFollow.at > RETRY_FOLLOW_MS) {
    retryFollow = undefined;
    return undefined;
  }
  const id = retryFollow.id;
  const row = rows.find((m) => m.id === id);
  if (row?.sendStatus !== "pending") return undefined;
  retryFollow = undefined;
  return row;
}
